/**
 * Klein symbool + optioneel label voor overleden personen (overlijdensdatum ingevuld).
 */
export default function DeceasedMark({ withLabel, className }: { withLabel?: boolean; className?: string }) {
  return (
    <span
      className={`deceased-mark${className ? ` ${className}` : ""}`}
      title="Overleden"
      aria-label="Overleden"
    >
      <svg
        className="deceased-mark__icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        aria-hidden
      >
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v10M8 11h8" />
      </svg>
      {withLabel ? <span className="deceased-mark__label">Overleden</span> : null}
    </span>
  );
}
